import { component } from 'picoapp';
import Swiper, { EffectFade, Autoplay } from 'swiper';

export default component(async (node) => {
  /**
   * Elements
   */
  const sliderElement = node.querySelector('.js-slider');
  const sliderWrapper = node.querySelector('.js-sliderWrapper');

  /**
   * Functions
   */
  const initSlider = () => {
    let slider;

    const reset = () => {
      if (slider?.destroy) {
        slider.destroy();
      }

      const isOverflowing = sliderElement.scrollWidth > sliderElement.getBoundingClientRect().width;

      sliderWrapper.classList[isOverflowing ? 'remove' : 'add']('justify-center');

      slider = new Swiper(sliderElement, {
        modules: [EffectFade, Autoplay],
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        speed: 1000,
        loop: true,
      });
    };

    reset();
    // window.addEventListener('resize', reset);
  };

  const init = () => {
    initSlider();
  };

  init();
});
